import { render, staticRenderFns } from "./examInfo.vue?vue&type=template&id=52bd7fd6&scoped=true&"
import script from "./examInfo.vue?vue&type=script&lang=js&"
export * from "./examInfo.vue?vue&type=script&lang=js&"
import style0 from "./examInfo.vue?vue&type=style&index=0&id=52bd7fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bd7fd6",
  null
  
)

export default component.exports